export default __webpack_public_path__ + "static/media/SDG5.e5e438c5.png";